import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Translate from '../common/Translate';
import useValue from '../../services/Form/useValue';

const removeFromArray = (array, option) => {
  const newArray = array.filter((ele) => ele !== option);
  return newArray;
};

const SelectMultiple = (props) => {
  const { elementIds } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { question, setDisableNav } = props;
  const defaultValue = question.default_value;
  const [array, setArray] = useValue(formId, sectionId, questionId, question.type, 'value', defaultValue);

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (array !== null && array !== [] && array !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const setMultipleValues = (option) => {
    if (!Array.isArray(array)) setArray([]);
    let newArray = [];
    if (array !== undefined && array !== null) newArray = [...array];
    if (newArray.includes(option)) {
      newArray = removeFromArray(newArray, option);
    } else newArray.push(option);
    setArray(newArray);
  };

  return (
    <>
      <div className="question-select-multiple" data-cy={questionId}>
        <Row>
          {question.options.map((option) => (
            <Col xs="6" md="4" lg="3" key={option} className="mb-3">
              <button
                type="button"
                className={
                  Array.isArray(array) && array.includes(option)
                    ? 'btn btn-block btn-value h-100 selected'
                    : 'btn btn-block btn-value h-100'
                }
                value="true"
                data-cy={option}
                data-test={`${questionId}-${option}-button`}
                onClick={() => {
                  setMultipleValues(option);
                }}
              >
                <Translate code={option} />
              </button>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

export default SelectMultiple;

SelectMultiple.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    options: PropTypes.oneOfType([PropTypes.array]).isRequired,
    type: PropTypes.oneOf(['select_multiple']).isRequired,
    default_value: PropTypes.string,
  }),
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
};

SelectMultiple.defaultProps = {
  question: {
    default_value: null,
  },
  setDisableNav: undefined,
};
